<template>
  <!-- prettier-ignore -->
  <carousel
    :per-page="1"
    :mouse-drag="true"
    :autoplay="true"
    :speed="1250"
    :loop="true"
    :autoplayTimeout="10000"
    :paginationPadding="5"
    :paginationSize="6"
    :paginationPosition="'bottom-overlay'"
  >
    <slide
      ><img
        class="slide-image"
        src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/1.jpeg?alt=media&token=eed03a19-a1bd-4642-a46a-2a33602c8056"
        alt=""
    /></slide>
    <slide
      ><img
        class="slide-image"
        src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/2.jpeg?alt=media&token=fb2a5201-715d-4ad9-b076-78bed79657f3"
        alt=""
    /></slide>
    <slide
      ><img
        class="slide-image"
        src="https://firebasestorage.googleapis.com/v0/b/jido-button.appspot.com/o/3.jpeg?alt=media&token=854691f7-69f4-498c-820c-6ab8c01360c2"
        alt=""
    /></slide>
  </carousel>
</template>

<script>
export default {};
</script>

<style scoped>
.slide-image {
  display: block;
  border-radius: 18px;
  width: 100%;
  margin: 0 auto;
}

@media (min-width: 1200px) {
  .slide-image {
    width: 75%;
  }
}
</style>
